// TodoAssistant is deprecated — functionality moved to AssistantPanel.
// Kept as a no-op export so existing imports don't break.

const TodoAssistant = () => null;

export default TodoAssistant;
